import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [-10.799255, 165.842636, 66.4],
  [-10.799237, 165.842518, 66.4],
  [-10.799221, 165.8424, 66.4],
  [-10.799205, 165.842271, 66.4],
  [-10.799185, 165.842153, 65.8],
  [-10.799164, 165.842013, 65.4],
  [-10.799142, 165.841895, 65],
  [-10.799122, 165.841756, 65],
  [-10.799104, 165.841638, 65],
];

export default stream;
